/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".emptyCarouselContainer[_ngcontent-%COMP%]{background-image:url(/images/industry-content/dashed-border.svg);background-color:#e6f3ff;border-radius:8px;margin:36px 0;padding:24px 2px 0 0;max-height:600px}.emptyCarouselContainer[_ngcontent-%COMP%]   .cardsContainer[_ngcontent-%COMP%]{margin-top:21px}.emptyCarouselContainer[_ngcontent-%COMP%]   .cardsContainer[_ngcontent-%COMP%]   .emptyCard[_ngcontent-%COMP%]{height:270px;background-color:#ddeefe;border:none;border-radius:8px}"];
export { styles as styles };
//# sourceMappingURL=industry-content-empty-carousel.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/industry-content-section/industry-content-empty-carousel/industry-content-empty-carousel.component.scss.shim.ngstyle.js
// module id = 1497
// module chunks = 26 27 28